export default __webpack_public_path__ + "static/media/1mm 2.d7d96626.jpg";